import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import { INITPAGING, NOTIFY } from "../based/Constants";
import PushingServices from "../based/services/PushingServices";
import { Notify } from "../based/Notify";

function SelectDesignModal({ show, onClose, onSave }) {
    const [busy, setBusy] = useState(false);
    const [pagingModel, setPagingModel] = useState({ ...INITPAGING, pageSize: 50 });
    const [lstModel, setLstModel] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const observer = useRef(null);

    useEffect(() => {
        if (show) {
            fetchData({ ...pagingModel, pageNumber: 1 });
        }
    }, [show]);

    const fetchData = async (page) => {
        setBusy(true);
        const [err, data] = await PushingServices.GetPushingProductTotalModels({ ...page, status: -1 });
        if (!err && data && data.listObjects && data.listObjects.length > 0) {
            if (page.pageNumber == 1) setLstModel(data.listObjects);
            else setLstModel([...lstModel, ...data.listObjects]);
            setPagingModel(data.paging);
            setHasMore(true);
        } else {
            if (page.pageNumber == 1) setLstModel([]);
            setHasMore(false);
            setPagingModel(page);
        }
        setBusy(false);
    };

    const setLastCollectionHandler = (element) => {
        if (busy || !hasMore) return;
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                let updatePaging = { ...pagingModel };
                updatePaging.pageNumber += 1;
                fetchData(updatePaging);
            }
        });
        if (element) observer.current.observe(element);
    };

    return (
        <CommonModal
            onClose={onClose}
            size="lg"
            show={show}
            title={`Chọn sản phẩm muốn đồng bộ`}
            onSave={() => {
                let selectedItems = lstModel.find((item) => item.isSelected);
                if (selectedItems) {
                    onSave({ ...selectedItems, sAppProductId: selectedItems.appProductId, sColorCode: selectedItems.colorCode });
                } else {
                    Notify(NOTIFY.WARNING, NOTIFY.WARNING, "Vui lòng chọn ít nhất một sản phẩm để đồng bộ");
                }
            }}
        >
            <Wrapper>
                <div className="filter-area">
                    <div className="search-area">
                        <input
                            type="text"
                            value={pagingModel.keyword}
                            placeholder="Tìm kiếm theo tên sản phẩm"
                            onChange={(e) => {
                                setPagingModel({ ...pagingModel, keyword: e.target.value });
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    fetchData({ ...pagingModel, pageNumber: 1 });
                                }
                            }}
                        />
                        <div
                            className="search-button cursor-pointer"
                            onClick={(e) => {
                                fetchData({ ...pagingModel, pageNumber: 1 });
                            }}
                        >
                            <i className="fa fa-search"></i>
                        </div>
                    </div>
                </div>
                <div className="list-item">
                    {lstModel.map((item, index) => (
                        <div
                            className={`item ${item.isSelected ? "selected" : ""} cursor-pointer`}
                            key={index}
                            ref={setLastCollectionHandler}
                            onClick={(e) => {
                                let lst = [...lstModel];
                                lst.forEach((i) => {
                                    i.isSelected = false;
                                });
                                let currentItem = lst[index];
                                currentItem.isSelected = !currentItem.isSelected;
                                setLstModel(lst);
                            }}
                        >
                            <div className="item-img">
                                <img src={item.thumbnail} alt="" />
                            </div>
                            <div className="item-name">
                                <span>{item.name}</span>
                            </div>
                            <div className="item-color">
                                <span>{item.colorName}</span>
                            </div>
                            <div className="item-count">
                                <span>5 dòng sản phẩm</span>
                            </div>
                            {item.isSelected && <span className="selected-badge">Đang chọn</span>}
                        </div>
                    ))}
                </div>
            </Wrapper>
        </CommonModal>
    );
}

export default SelectDesignModal;

const Wrapper = styled.div`
    .search-area {
        display: flex;
        align-items: center;
        border: 1px solid #d9d9d9;
        background: #fff;
        width: 25%;
        padding: 10px;
    }

    .search-area input {
        border: none;
        width: 100%;
    }

    .search-button.cursor-pointer {
        margin-left: auto;
    }
    .item-img {
        width: 100%;
        aspect-ratio: 1;
    }
    .item.selected {
        border: 1px solid #d9d9d9;
        opacity: 0.9;
        background: #ffe3c0;
        position: relative;
    }

    span.selected-badge {
        position: absolute;
        top: 0;
        left: 0;
        background: #febd6a;
        padding: 5px 10px;
        overflow: hidden;
        color: #000;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .list-item {
        display: flex;
        flex-wrap: wrap;
    }

    .item-img {
        padding: 4px;
    }

    .item-img img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .item {
        width: 170px;
        margin: 10px;
        border: 1px solid #d9d9d9;
        background: #fff;
    }

    .item-name {
        color: #000;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding: 4px 10px;

        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .item-color {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        padding: 4px 10px;
    }

    .item-count {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        padding: 4px 10px;
    }
`;
